import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from 'library/utils';

const Loading = ({ className }) => {
  return <Loader2 className={cn('loading tw-mr-0 !tw-h-5 !tw-w-5 tw-animate-spin', className)} />;
};

export default Loading;
